import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {ReduxFormSelectPickerGeneric} from 'shells/redux-form-fields/select-picker-generic/select-picker-generic';
import {ReduxFormSelectPickerMulti} from 'shells/redux-form-fields/select-picker-generic/select-picker-multi';

type Props = FieldProps & {
    enumOptions: string[];
    isMulti?: boolean;
    isRequired?: boolean;
};

export function DecisionFieldSelect(props: Props) {
    // @ts-expect-error
    const options = props.enumOptions.map((opt) => {
        return {
            label: opt,
            value: opt,
        };
    });

    // @ts-expect-error
    const selectedValue = options.find((field) => field.value === props.input.value);

    if (props.isMulti) {
        return (
            <ReduxFormSelectPickerMulti
                {...props}
                options={options}
                placeholder='Select'
                value={selectedValue}
                autoFocus={false}
                // @ts-expect-error
                onChange={(option) => {
                    // @ts-expect-error
                    props.input.onChange(option.map((opt) => opt.value));
                }}
            />
        );
    }

    return (
        <ReduxFormSelectPickerGeneric
            {...props}
            options={options}
            placeholder='Select'
            value={selectedValue}
            autoFocus={false}
        />
    );
}
